import { Upload } from 'antd'
import moment from 'moment'
import React, { useState, useCallback, useEffect } from 'react'
import Loading from 'custom/assets/loaders/Loading'
import { NeoOTP, NeoSuccess } from '../../components/FormComponents'
import NeoButton from '../../components/NeoButton/NeoButton'
import AccountDisplay from '../../components/account-display/account-display'
import TransferService from '../../services/transfer.service'
import LayoutWithAccountCard from '../Layout/layout-account-card'
import DownloadIcon from 'custom/assets/common-icons/Download.svg'
import { Field, Formik, Form } from 'formik'
import InputError from '../../components/InputError/InputError'
import { useSelector } from 'react-redux'
import {
  getAccountListSelector,
  getCurrentAccDetailsSelector,
  getMenuListSelector,
} from '../../store/selectors/app.selector'
import validationConfig from 'custom/config/validation.config.json'
const salaryUploadConfig = validationConfig['salaryUpload']
import { SALARY_UPLOAD_KEYS, BUTTON_KEYS } from '../../utils/translation-constants'
import { useTranslation } from 'react-i18next'
import NeoInput from '../../components/NeoInput/NeoInput'
import { InternalTransferSchema, validateFileUpload } from '../../schemas/transfers'
import NotificationService from '../../services/notification.service'
const { Dragger } = Upload

export default function SalaryUpload() {
  const [stage, setStage] = useState(1)
  const [uploadFile, setUploadFile] = useState('')
  const [selectedFileName, setSelectedFileName] = useState('')
  const [fileType, setFileType] = useState('N')
  const [verifyDetails, setVerifyDetails] = useState({})
  const [otp, setOtp] = useState('')
  const [message, setMessage] = useState('')
  const [loading, setLoading] = useState(false)
  const accountList = useSelector(getAccountListSelector) || []
  const currentAccountDetail = useSelector(getCurrentAccDetailsSelector)
  const [accountNo, setAccountNo] = useState('')
  const { t } = useTranslation()
  const [fileProcessList, setFileProcessList] = useState([])
  const [requestValues, setRequestValues] = useState({})
  const menuConfig = useSelector(getMenuListSelector)['FILE_UPLOAD'] || {}
  const [fileProcessId, setFileProcessId] = useState(0)

  useEffect(() => {
    getFileProcessList()
  }, [])

  const handleAction = useCallback(({ file, onSuccess }) => {
    console.log(file)
    setTimeout(() => {
      onSuccess('ok')
    }, 0)
  })

  const getFileProcessList = useCallback(async () => {
    try {
      const response = await TransferService.getFileProcessList()
      if (response.status === 200) {
        setFileProcessList(response.data)
      }
    } catch (err) {}
  }, [])

  const onChange = useCallback((info) => {
    if (info.file.status === 'done') {
      console.log(info?.file?.originFileObj?.name)
      setSelectedFileName(info?.file?.originFileObj?.name)
      setUploadFile(info?.file?.originFileObj)
    }
  })

  const onRemove = useCallback(() => {
    setUploadFile('')
    setSelectedFileName('')
  })

  const onVerify = useCallback(
    async (data) => {
      
      try {
        if (selectedFileName.length === 0) {
          NotificationService.showErrorMessage('Upload file should be required ')
          return
        }
        const fileProcessedDetails = fileProcessList.filter(
          (ele) => ele.fileProcessName === data.fileProcessName,
        )[0]
        setRequestValues({ ...data, ...fileProcessedDetails })
        let formData = new FormData()
        formData.append('file', uploadFile)
        formData.append('fileProcessId', fileProcessedDetails.fileProcessId)
        formData.append('totalAmount', data.amount)
        formData.append('remarks', data.remarks)
        formData.append('srcAccNo', currentAccountDetail.accountNo)
        formData.append('srcAccCcy', currentAccountDetail.currency)
        formData.append('srcAccBrn', currentAccountDetail.brnCode)
        formData.append('valueDate', moment(data.valueDate).format('DD-MM-YYYY'))
        setLoading(true)
        const response = await TransferService.onVerifyFileUpload(formData)
        if (response.status === 200) {
          setVerifyDetails(response.data)
          setLoading(false)

          if (response.data['otpEnable']) {
            setStage(2)
            return
          }
        }
      } catch (err) {
        console.log(err)
        setLoading(false)
      }
    },
    [uploadFile, selectedFileName, currentAccountDetail],
  )

  const onConfirm = useCallback(async () => {
    try {
      setLoading(true)
      let formData = new FormData()
      formData.append('file', uploadFile)
      formData.append('fileProcessId', requestValues.fileProcessId)
      formData.append('totalAmount', requestValues.amount)
      formData.append('srcAccNo', currentAccountDetail.accountNo)
      formData.append('remarks', requestValues.remarks)
      formData.append('srcAccCcy', currentAccountDetail.currency)
      formData.append('srcAccBrn', currentAccountDetail.brnCode)
      formData.append('valueDate', moment(requestValues.valueDate).format('DD-MM-YYYY'))
      formData.append('otp', otp)
      formData.append('randomKey', verifyDetails.randomKey)
      const response = await TransferService.onConfirmFileUpload(formData)
      if (response.status === 200) {
        setLoading(false)
        setMessage(response.data['message'])
        setStage(3)
      }
    } catch (err) {
      setLoading(false)
      setOtp('')
    }
  }, [verifyDetails, otp, requestValues, uploadFile, currentAccountDetail])

  const onDownload = useCallback(async () => {
    try {
      const reqParams = {
        requestId: 'DOWNLOADTEMPLATE',
        fileProcessId: fileProcessId,
      }
      if (fileProcessId === 0) {
        NotificationService.showErrorMessage(`Please Select Process Name`)
      } else {
        await TransferService.downloadTemplate(reqParams)
      }
    } catch (err) {
      setLoading(false)
    }
  }, [fileProcessId])

  function renderSwitch() {
    switch (stage) {
      case 1:
        return renderForm()
      case 2:
        return <NeoOTP otp={otp} setOTP={setOtp} onSubmit={onConfirm} loading={loading} />
      case 3:
        return <NeoSuccess message={message} linkPath='/transfers' />
      default:
        return renderForm()
    }
  }

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  const onChangeProcessId = useCallback(
    (value) => {
      const fileProcessIdCopy = fileProcessList?.filter((e) =>
        e.fileProcessName === value ? e : '',
      )[0]
      setFileProcessId(fileProcessIdCopy.fileProcessId)
    },
    [fileProcessList, fileProcessId],
  )

  function renderForm() {
    return (
      <>
        <AccountDisplay currentAccountDetail={currentAccountDetail} />
        <Formik
          initialValues={{
            amount: '',
            fileProcessName: '',
            valueDate: '',
            remarks: '',
          }}
          enableReinitialize
          validationSchema={validateFileUpload}
          onSubmit={onVerify}>
          {({ errors, touched, values, handleChange, setFieldValue }) => (
            <Form>
              <div className='row'>
                <div className='form-group col-12'>
                  <NeoInput
                    tabIndex='1'
                    showAsterisk={salaryUploadConfig['isAccountNoRequired']}
                    text={t(SALARY_UPLOAD_KEYS.PROCESS_NAME)}
                    name='fileProcessName'
                    mode='select'
                    list={fileProcessList}
                    keyValue='fileProcessName'
                    onChange={(e) => {
                      handleChange(e)
                      onChangeProcessId(e.target.value)
                    }}
                  />
                  <InputError text={errors.fileProcessName} touched={touched.fileProcessName} />
                </div>

                <div className='form-group col-6'>
                  <NeoInput
                    tabIndex='2'
                    showAsterisk={salaryUploadConfig['isAccountNoRequired']}
                    mode='amount'
                    text={t(SALARY_UPLOAD_KEYS.TOTAL_AMOUNT)}
                    onChange={(values) => {
                      setFieldValue('amount', values.value)
                    }}
                    name='totalAmount'
                  />
                  <InputError text={errors.amount} touched={touched.amount} />
                </div>

                <div className='form-group col-6' style={{ marginBottom: 15 }}>
                  <NeoInput
                    tabIndex='3'
                    text={t(SALARY_UPLOAD_KEYS.VALUE_DATE)}
                    name='valueDate'
                    type='date'
                    onChange={handleChange}
                    min={moment(new Date()).format('YYYY-MM-DD')}
                    value={values.valueDate}
                  />
                </div>
                <div className='form-group col-12' style={{ marginBottom: 15 }}>
                  <NeoInput
                    tabIndex='4'
                    text={t(SALARY_UPLOAD_KEYS.NARRATIVE)}
                    onChange={handleChange}
                    name='remarks'
                    showAsterisk={true}
                    value={values.remarks}
                  />
                  <InputError text={errors.remarks} touched={touched.remarks} />
                </div>
              </div>
              <Dragger
                tabIndex={'4'}
                accept='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel'
                height={100}
                multiple={false}
                listType={'picture'}
                onChange={onChange}
                onRemove={onRemove}
                customRequest={handleAction}>
                <p className='ant-upload-text' style={{ fontSize: 12 }}>
                  {t(SALARY_UPLOAD_KEYS.CLICK_OR_DRAG)}
                </p>
              </Dragger>

              <div className='mt-3'>
                {loading ? (
                  renderLoading()
                ) : (
                  <NeoButton
                    tabIndex='5'
                    type='submit'
                    mode='newDesign'
                    disabled={loading}
                    text={t(BUTTON_KEYS.SUBMIT)}
                  />
                )}
              </div>
            </Form>
          )}
        </Formik>
      </>
    )
  }

  return (
    <LayoutWithAccountCard keyPath={'SALARY_UPLOAD'} breadCumKey='SALARY_UPLOAD'>
      <div className='new-design-form-style'>
        <div
          className='d-flex'
          style={{ justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
          <div className='heading-style' style={{ margin: 0 }}>
            {t(SALARY_UPLOAD_KEYS.TITLE)}
          </div>
          {menuConfig['TEMPLATE'] && (
            <button
              tabIndex={'1'}
              onClick={() => onDownload()}
              type='button'
              className='btn detailed-statement-btn'
              style={{ padding: '5px 25px' }}>
              <img src={DownloadIcon} alt='' className='mr-2' height={23} width={20} />
              <span className='font-weight-600'>{t(BUTTON_KEYS.TEMPLATE)}</span>
            </button>
          )}
        </div>
        <div>{renderSwitch()}</div>
      </div>
    </LayoutWithAccountCard>
  )
}
